import moment from 'moment';

export const shortenedDate = 'MM/DD';
export const shortenedDate2 = 'M/DD';
export const fullDate = 'MM/DD/YYYY';
export const defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
export const fullDateTime = 'MM/DD/YYYY h:mm:ss A';
export const fullDateShort = 'MM/DD/YY';
export const fullDateShortNoLeadingZeroes = 'M/D/YY';
export const fullDateTimeNoSeconds = 'MM/DD/YYYY h:mm A';
export const generalDate = 'MMM YYYY';
export const fullDateNoPad = 'M/D/YYYY';
export const fullDateISO = 'YYYY-MM-DD';
export const fullGeneralDate = 'MMMM YYYY';
export const fullMonth = 'MMMM';
export const dayOfMonth = 'MMM Do, YYYY';
export const monthYear = 'MM/YYYY';
export const year = 'YYYY';
export const shortMonth = 'MMM';
export const shortDay = 'ddd';
export const shortGeneralDateWithDay = 'MMM DD, YYYY';
export const fullGeneralDateWithDay = 'MMMM DD, YYYY';
export const fullDateTimeWithTz = 'MMMM DD, YYYY h:mm A z';
export const shortenedDateWithTime = 'MM/DD [at] LT';
export const weekdayDateWithTime = 'ddd, MMM do, LT';
export const shortenedWeekdayDate = 'MMM D, YYYY (dddd)';
export const dayOfMonthNoYear = 'MMMM Do';
export const dayOfAbreviatedMonthNoYear = 'MMM Do';
export const shortenedWeekdayDateWithYear = 'dddd, MMMM Do YYYY';

export const fullDateAtTime = 'MMM Do YYYY [at] h:mm A';
export const shortDateAtTime = 'MMM Do [at] h:mm A';
export const shortDatetime = 'MMM D, h:mm A';

// TIME FORMATS ------------------------------------------
export const hourMin = 'h:mm A';
export const hourMinWithTZ = 'h:mm A z';

export function formatDate(date, format) {
  return moment.utc(date).format(format);
}
